
import React, { useEffect, useState } from 'react';
import './App.css';
import image1 from './image/1.png';
import image2 from './image/2.png';
import analyticsController from './AnalyticsController';

const App = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [statsData, setStatsData] = useState({
    monthlyMinutes: 522253,
    realtimeEvents: 935812506,
    realtimeUsers: 63,
    totalNumberDownloaded: 3851441
  });
  const [copied, setCopied] = useState(false);


  // Auto-slide for backers carousel
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % 3);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  // Fetch stats data
  useEffect(() => {
    const fetchStats = async () => {
      try {
        const response = await fetch('https://tbymwdm93a.execute-api.eu-west-3.amazonaws.com/ga-report', {
          method: 'GET',
          headers: {
            'accept': '*/*',
            'accept-language': 'vi,en-US;q=0.9,en;q=0.8,es;q=0.7',
            'origin': 'https://www.web3intelligence.com',
            'referer': 'https://www.web3intelligence.com/',
            'sec-fetch-dest': 'empty',
            'sec-fetch-mode': 'cors',
            'sec-fetch-site': 'cross-site',
            'user-agent': 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/141.0.0.0 Safari/537.36'
          }
        });
        
        if (response.ok) {
          const data = await response.json();
          setStatsData({
            monthlyMinutes: Math.round(data.monthlyMinutes),
            realtimeEvents: data.realtimeEvents,
            realtimeUsers: data.realtimeUsers,
            totalNumberDownloaded: data.totalNumberDownloaded
          });
        }
      } catch (error) {
        console.log('Failed to fetch stats:', error);
        // Keep default values if API fails
      }
    };

    // Fetch immediately
    fetchStats();
    
    // Fetch every 30 seconds
    const interval = setInterval(fetchStats, 30000);
    
    return () => clearInterval(interval);
  }, []);

  // Increment realtimeEvents every second
  useEffect(() => {
    const incrementInterval = setInterval(() => {
      setStatsData(prevData => ({
        ...prevData,
        realtimeEvents: prevData.realtimeEvents + Math.floor(Math.random() * 46) + 5 // Random 5-50
      }));
    }, 1000);

    return () => clearInterval(incrementInterval);
  }, []);
  useEffect(() => {
    analyticsController.trackPageView();
  }, []);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const copyToClipboard = async (text) => {
    try {
      await navigator.clipboard.writeText(text);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy: ', err);
    }
  };

  const trackClick = ({ event_name, href } = {}) => {
    analyticsController.trackEvent(event_name, {
      href,
      path: window.location.pathname
    });
  };

  return (
    <div className="text-white/90 font-sans selection:bg-accent/30">
      <div className="starfield"></div>


      {/* Header */}
      <header className="sticky top-0 z-50 border-b border-white/5 bg-base/80 backdrop-blur">
        <div className="max-w-7xl mx-auto px-2 sm:px-4 lg:px-8">
          <div className="flex items-center justify-between py-4">
            <a
              href="#trade"
              className="flex items-center gap-2"
              onClick={() => trackClick({ event_name: 'click_logo', href: '#trade' })}
            >
              <img
                src="/logo.png"
                alt="Dopamine logo"
                className="h-8 w-8 rounded-xl shadow-glow"
                onError={(e) => {
                  e.target.replaceWith(
                    Object.assign(document.createElement('div'), {
                      className: 'h-8 w-8 rounded-xl bg-gradient-to-tr from-accent to-neon shadow-glow'
                    })
                  );
                }}
              />
              <span className="text-white font-semibold tracking-tight">Dopamine</span>
            </a>
            <nav className="hidden md:flex items-center gap-6 text-sm ml-auto">
              <a href="#trade" className="hover:text-white" onClick={() => trackClick({ event_name: 'click_get_dope', href: '#trade' })}>Get $DOPE</a>
              <a href="#how" className="hover:text-white" onClick={() => trackClick({ event_name: 'click_how', href: '#how' })}>How</a>
              <a href="#future" className="hover:text-white" onClick={() => trackClick({ event_name: 'click_features', href: '#future' })}>Features</a>
              <a href="#token" className="hover:text-white" onClick={() => trackClick({ event_name: 'click_token', href: '#token' })}>Token</a>
              <a href="#partners" className="hover:text-white" onClick={() => trackClick({ event_name: 'click_backers', href: '#partners' })}>Backers</a>
              <a href="#app" className="hover:text-white" onClick={() => trackClick({ event_name: 'click_app', href: '#app' })}>App</a>
              <a href="#faq" className="hover:text-white" onClick={() => trackClick({ event_name: 'click_faq', href: '#faq' })}>FAQ</a>
              <a href="/privacy.html" className="hover:text-white" onClick={() => trackClick({ event_name: 'click_privacy', href: '/privacy.html' })}>Privacy</a>
              <a href="/term-of-use.html" className="hover:text-white" onClick={() => trackClick({ event_name: 'click_terms', href: '/term-of-use.html' })}>Terms</a>
            </nav>
            <div className="flex items-center gap-3">
              {/*<button*/}
              {/*  onClick={handleConnectWallet}*/}
              {/*  className="px-4 py-2 rounded-xl bg-gradient-to-r from-accent/90 to-neon/90 text-base font-semibold shadow-glow hover:scale-[1.02] active:scale-[.99] transition"*/}
              {/*>*/}
              {/*  Connect Wallet*/}
              {/*</button>*/}
              <button
                className="md:hidden p-2 rounded-lg border border-white/10"
                aria-label="Open Menu"
                onClick={() => {
                  toggleMobileMenu();
                  trackClick({ event_name: 'click_toggle_menu' });
                }}
              >
                ☰
              </button>
            </div>
          </div>
          <div className={`md:hidden ${mobileMenuOpen ? 'block' : 'hidden'} pb-4`}>
            <div className="divider mb-4"></div>
            <nav className="grid gap-3">
              <a href="#trade" className="py-2" onClick={() => trackClick({ event_name: 'click_get_dope', href: '#trade' })}>Get $DOPE</a>
              <a href="#how" className="py-2" onClick={() => trackClick({ event_name: 'click_how', href: '#how' })}>How</a>
              <a href="#future" className="py-2" onClick={() => trackClick({ event_name: 'click_features', href: '#future' })}>Features</a>
              <a href="#token" className="py-2" onClick={() => trackClick({ event_name: 'click_token', href: '#token' })}>Token</a>
              <a href="#partners" className="py-2" onClick={() => trackClick({ event_name: 'click_backers', href: '#partners' })}>Backers</a>
              <a href="#app" className="py-2" onClick={() => trackClick({ event_name: 'click_app', href: '#app' })}>App</a>
              <a href="#faq" className="py-2" onClick={() => trackClick({ event_name: 'click_faq', href: '#faq' })}>FAQ</a>
              <a href="/privacy.html" className="py-2" onClick={() => trackClick({ event_name: 'click_privacy', href: '/privacy.html' })}>Privacy</a>
              <a href="/term-of-use.html" className="py-2" onClick={() => trackClick({ event_name: 'click_terms', href: '/term-of-use.html' })}>Terms</a>
            </nav>
          </div>
        </div>
      </header>

      {/* HERO */}
      <section id="trade" className="relative overflow-hidden bg-mesh">
        <div className="absolute -top-32 -left-20 blur-spot w-[400px] h-[400px] bg-accent/25"></div>
        <div className="absolute -bottom-40 right-20 blur-spot w-[420px] h-[420px] bg-neon/20"></div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
          <div className="grid lg:grid-cols-2 gap-8 lg:gap-10 items-center">
            <div className="text-center lg:text-left">
              <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-white/10 bg-white/5 text-xs text-white/70 mb-4">
                <span className="h-2 w-2 bg-lime rounded-full animate-pulse"></span>
                <span>Now Trading</span>
              </div>
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.05]">
                Own <span className="text-transparent bg-clip-text bg-gradient-to-r from-accent to-neon">$DOPE</span> on Solana
              </h1>
              <p className="mt-4 sm:mt-5  max-w-xl mx-auto lg:mx-0">$DOPE powers rewards and in‑app perks across the Dopamine ecosystem. Trade it on your preferred exchange, then explore the app.</p>

              <div className="mt-6 sm:mt-8 flex flex-col items-center lg:items-start gap-4">
                <div className="text-xs text-white/60 text-center lg:text-left">Ticker: <strong className="text-white">$DOPE</strong> • Chain: <strong className="text-white">Solana</strong></div>
                <div className="text-sm text-white/70 text-center lg:text-left max-w-md">
                  Available on DEX. The Max supply (125M tokens) is fully distributed and unlocked. Choose your preferred platform below.
                </div>
              </div>

            </div>
            <div className="glass rounded-3xl p-4 sm:p-6 lg:p-8 shadow-deep mt-8 lg:mt-0">
              <div className="flex flex-col sm:flex-row sm:items-center justify-between mb-6 gap-2">
                <h3 className="text-xl font-semibold">Where to buy $DOPE</h3>
                <div className="flex items-center gap-3 text-xs text-white/60">
                  <a
                    className="underline hover:text-white transition-colors"
                    href="https://coinmarketcap.com/currencies/dopamine-app/"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => trackClick({ event_name: 'click_coinmarketcap', href: 'https://coinmarketcap.com/currencies/dopamine-app/' })}
                  >
                    CoinMarketCap
                  </a>
                  <a
                    className="underline hover:text-white transition-colors"
                    href="https://www.coingecko.com/en/coins/dopamine"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => trackClick({ event_name: 'click_coingecko', href: 'https://www.coingecko.com/en/coins/dopamine' })}
                  >
                    CoinGecko
                  </a>
                </div>
              </div>
              
              <div className="rounded-2xl border border-white/10 p-4 sm:p-6">
                {/* Exchange buttons grid */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-6">
                  <a
                    href="https://jup.ag/swap?sell=So11111111111111111111111111111111111111112&buy=8Kqmghm1mkXbKYqt2wGnHxwnRdEjD9nayNKD3EanWkcD"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group px-4 py-4 rounded-xl glass text-center hover:bg-white/10 hover:scale-[1.02] transition-all duration-200"
                    onClick={() => trackClick({ event_name: 'click_jupiter', href: 'https://jup.ag/swap?sell=So11111111111111111111111111111111111111112&buy=8Kqmghm1mkXbKYqt2wGnHxwnRdEjD9nayNKD3EanWkcD' })}
                  >
                    <div className="text-sm">Jupiter</div>
                    <div className="text-xs opacity-60">DEX</div>
                  </a>
                  <a
                    href="https://raydium.io/swap/?inputMint=sol&outputMint=8Kqmghm1mkXbKYqt2wGnHxwnRdEjD9nayNKD3EanWkcD"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group px-4 py-4 rounded-xl glass text-center hover:bg-white/10 hover:scale-[1.02] transition-all duration-200"
                    onClick={() => trackClick({ event_name: 'click_raydium', href: 'https://raydium.io/swap/?inputMint=sol&outputMint=8Kqmghm1mkXbKYqt2wGnHxwnRdEjD9nayNKD3EanWkcD' })}
                  >
                    <div className="text-sm">Raydium</div>
                    <div className="text-xs opacity-60">DEX</div>
                  </a>
                </div>
                
                {/* Mint address */}
                <div className="pt-4 border-t border-white/10">
                  <div className="text-xs text-white/60 mb-2">Contract Address:</div>
                  <div className="flex items-center gap-2">
                    <a
                      href="https://solscan.io/token/8Kqmghm1mkXbKYqt2wGnHxwnRdEjD9nayNKD3EanWkcD"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="flex-1 text-xs text-white/80 break-all font-mono bg-black/20 hover:bg-black/30 px-3 py-2 rounded-lg cursor-pointer transition-colors hover:text-white"
                      title="Click to view on Solscan"
                      onClick={() => trackClick({ event_name: 'click_contract_address', href: 'https://solscan.io/token/8Kqmghm1mkXbKYqt2wGnHxwnRdEjD9nayNKD3EanWkcD' })}
                    >
                      8Kqmghm1mkXbKYqt2wGnHxwnRdEjD9nayNKD3EanWkcD
                    </a>
                    <button
                      onClick={() => {
                        copyToClipboard('8Kqmghm1mkXbKYqt2wGnHxwnRdEjD9nayNKD3EanWkcD');
                        trackClick({ event_name: 'click_copy_contract_address' });
                      }}
                      className="px-3 py-2 rounded-lg bg-white/10 hover:bg-white/20 transition-colors text-xs text-white/80 hover:text-white w-9"
                      title="Copy address"
                    >
                      {copied ? ' ✓ ' : '📋'}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* STATS DASHBOARD */}
      <section className="py-16 lg:py-24 relative overflow-hidden">
        {/* Background Effects */}
        <div className="absolute inset-0 bg-gradient-to-br from-accent/5 via-transparent to-neon/5"></div>
        <div className="absolute top-10 left-10 w-32 h-32 bg-accent/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-40 h-40 bg-neon/10 rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 left-1/4 w-24 h-24 bg-accent/5 rounded-full blur-2xl"></div>
        
        <div className="max-w-7xl mx-auto px-2 sm:px-4 lg:px-8 relative z-10">
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl font-bold mb-4">Live Ecosystem Data</h2>
            <p className="text-white/70 max-w-2xl mx-auto">Real-time metrics from our growing community</p>
          </div>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {/* Lifetime Downloads */}
            <div className="glass-light rounded-2xl p-6 text-center hover:scale-[1.02] transition-all duration-300 group">
              <div className="text-white/70 text-sm mb-2">Lifetime Downloads</div>
              <div className="text-3xl sm:text-4xl font-bold text-white">
                {statsData.totalNumberDownloaded.toLocaleString()}
              </div>
            </div>

            {/* Current Users in Real Time */}
            <div className="glass-light rounded-2xl p-6 text-center hover:scale-[1.02] transition-all duration-300 group">
              <div className="text-white/70 text-sm mb-2">Current Users in Real Time</div>
              <div className="text-3xl sm:text-4xl font-bold text-white">
                {statsData.realtimeUsers}
              </div>
            </div>

            {/* Ecosystem Events */}
            <div className="glass-light rounded-2xl p-6 text-center hover:scale-[1.02] transition-all duration-300 group">
              <div className="text-white/70 text-sm mb-2">Ecosystem Events</div>
              <div className="text-3xl sm:text-4xl font-bold text-white">
                {statsData.realtimeEvents.toLocaleString()}
              </div>
            </div>

            {/* Unregretted User-Minutes */}
            <div className="glass-light rounded-2xl p-6 text-center hover:scale-[1.02] transition-all duration-300 group">
              <div className="text-white/70 text-sm mb-2">User Minutes per Month</div>
              <div className="text-3xl sm:text-4xl font-bold text-white">
                {statsData.monthlyMinutes.toLocaleString()}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* HOW TO GET */}
      <section id="how" className="py-16 lg:py-24">
        <div className="max-w-4xl mx-auto px-2 sm:px-4 lg:px-8">
          <div className="text-center">
            <h2 className="text-3xl sm:text-4xl font-bold">How to get $DOPE</h2>
            <p className="mt-3 text-white/70 max-w-2xl mx-auto">Pick your path: DEX, or bridge to Solana first, then swap.</p>
            <div className="mt-8 grid gap-4 max-w-2xl mx-auto">
              <div className="glass-light rounded-2xl p-5">
                <div className="text-sm text-white/60">Option A</div>
                <div className="font-semibold">DEX: Raydium</div>
                <p className="text-white/70 text-sm mt-1">Connect on Raydium and swap pair.</p>
              </div>
              <div className="glass-light rounded-2xl p-5">
                <div className="text-sm text-white/60">Option A</div>
                <div className="font-semibold">DEX: Jupiter (Solana)</div>
                <p className="text-white/70 text-sm mt-1">Connect your Solana wallet and swap with minimal slippage.</p>
              </div>
              <div className="glass-light rounded-2xl p-5">
                <div className="text-sm text-white/60">Option C</div>
                <div className="font-semibold">Bridge to Solana</div>
                <p className="text-white/70 text-sm mt-1">Need funds on Solana? Bridge from other chains, then swap to $DOPE.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FEATURES */}
      <section id="future" className="py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-2 sm:px-4 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl font-bold">More Features</h2>
            <p className="mt-3 text-white/70 max-w-2xl mx-auto">Discover all the powerful features available in the Dopamine ecosystem</p>
          </div>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {/* Track Coins */}
            <div className="glass-light rounded-2xl p-6 text-center hover:scale-[1.02] transition-all duration-300 group">
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-xl bg-gradient-to-r from-accent/20 to-neon/20 group-hover:from-accent/30 group-hover:to-neon/30 transition-all duration-300">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold mb-2">Track Coins</h3>
              <p className="text-white/70 text-sm">Keep track of all your favorite projects from a collection of 10,000+ coins</p>
            </div>

            {/* Anti-Money Laundering */}
            <div className="glass-light rounded-2xl p-6 text-center hover:scale-[1.02] transition-all duration-300 group">
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-xl bg-gradient-to-r from-accent/20 to-neon/20 group-hover:from-accent/30 group-hover:to-neon/30 transition-all duration-300">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold mb-2">Anti-Money Laundering</h3>
              <p className="text-white/70 text-sm">Find out if your wallet has been involved in fraud and learn about your risk score</p>
            </div>

            {/* Hot Opportunities */}
            <div className="glass-light rounded-2xl p-6 text-center hover:scale-[1.02] transition-all duration-300 group">
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-xl bg-gradient-to-r from-accent/20 to-neon/20 group-hover:from-accent/30 group-hover:to-neon/30 transition-all duration-300">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold mb-2">Hot Opportunities</h3>
              <p className="text-white/70 text-sm">Stay informed on the coins that create big moves in the market</p>
            </div>

            {/* Buy Crypto */}
            <div className="glass-light rounded-2xl p-6 text-center hover:scale-[1.02] transition-all duration-300 group">
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-xl bg-gradient-to-r from-accent/20 to-neon/20 group-hover:from-accent/30 group-hover:to-neon/30 transition-all duration-300">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold mb-2">Buy Crypto</h3>
              <p className="text-white/70 text-sm">Use your credit or debit card to buy crypto straight through the app</p>
            </div>

            {/* Portfolio Tracker */}
            <div className="glass-light rounded-2xl p-6 text-center hover:scale-[1.02] transition-all duration-300 group">
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-xl bg-gradient-to-r from-accent/20 to-neon/20 group-hover:from-accent/30 group-hover:to-neon/30 transition-all duration-300">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold mb-2">Portfolio Tracker</h3>
              <p className="text-white/70 text-sm">Stay on top of your investments and know exactly when you have to sell</p>
            </div>

            {/* Price Alerts */}
            <div className="glass-light rounded-2xl p-6 text-center hover:scale-[1.02] transition-all duration-300 group">
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-xl bg-gradient-to-r from-accent/20 to-neon/20 group-hover:from-accent/30 group-hover:to-neon/30 transition-all duration-300">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 17h5l-5 5v-5zM4.828 7l2.586 2.586a2 2 0 002.828 0L12 7M4.828 17l2.586-2.586a2 2 0 012.828 0L12 17" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold mb-2">Price Alerts</h3>
              <p className="text-white/70 text-sm">Receive push notifications directly when the price changes</p>
            </div>

            {/* Trade Crypto */}
            <div className="glass-light rounded-2xl p-6 text-center hover:scale-[1.02] transition-all duration-300 group">
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-xl bg-gradient-to-r from-accent/20 to-neon/20 group-hover:from-accent/30 group-hover:to-neon/30 transition-all duration-300">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7h12m0 0l-4-4m4 4l-4 4m0 6H4m0 0l4 4m-4-4l4-4" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold mb-2">Trade Crypto</h3>
              <p className="text-white/70 text-sm">Swap coins with minimum fee, multiple chains support</p>
            </div>

            {/* Teleport Crypto */}
            <div className="glass-light rounded-2xl p-6 text-center hover:scale-[1.02] transition-all duration-300 group">
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-xl bg-gradient-to-r from-accent/20 to-neon/20 group-hover:from-accent/30 group-hover:to-neon/30 transition-all duration-300">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold mb-2">Teleport Crypto</h3>
              <p className="text-white/70 text-sm">Transfer your stable-coins from one blockchain to another</p>
            </div>

            {/* Manage NFTs */}
            <div className="glass-light rounded-2xl p-6 text-center hover:scale-[1.02] transition-all duration-300 group">
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-xl bg-gradient-to-r from-accent/20 to-neon/20 group-hover:from-accent/30 group-hover:to-neon/30 transition-all duration-300">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold mb-2">Manage NFTs</h3>
              <p className="text-white/70 text-sm">Send and Receive NFTs in different blockchains like Ethereum, BSC, Fusion, and more</p>
            </div>

            {/* Assets Allocation */}
            <div className="glass-light rounded-2xl p-6 text-center hover:scale-[1.02] transition-all duration-300 group">
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-xl bg-gradient-to-r from-accent/20 to-neon/20 group-hover:from-accent/30 group-hover:to-neon/30 transition-all duration-300">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold mb-2">Assets Allocation</h3>
              <p className="text-white/70 text-sm">Advanced portfolio management with detailed asset allocation tracking</p>
            </div>

            {/* Live Videos */}
            <div className="glass-light rounded-2xl p-6 text-center hover:scale-[1.02] transition-all duration-300 group">
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-xl bg-gradient-to-r from-accent/20 to-neon/20 group-hover:from-accent/30 group-hover:to-neon/30 transition-all duration-300">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold mb-2">Live Videos</h3>
              <p className="text-white/70 text-sm">Latest video content for staying up to date on a fast moving crypto market</p>
            </div>

            {/* Podcasts */}
            <div className="glass-light rounded-2xl p-6 text-center hover:scale-[1.02] transition-all duration-300 group">
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-xl bg-gradient-to-r from-accent/20 to-neon/20 group-hover:from-accent/30 group-hover:to-neon/30 transition-all duration-300">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold mb-2">Podcasts</h3>
              <p className="text-white/70 text-sm">Crypto currency podcasts for the latest news, trends, and technology updates</p>
            </div>

            {/* News */}
            <div className="glass-light rounded-2xl p-6 text-center hover:scale-[1.02] transition-all duration-300 group">
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-xl bg-gradient-to-r from-accent/20 to-neon/20 group-hover:from-accent/30 group-hover:to-neon/30 transition-all duration-300">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold mb-2">News</h3>
              <p className="text-white/70 text-sm">Aggregated news sources for the latest information on the market</p>
            </div>

            {/* Play to Earn */}
            <div className="glass-light rounded-2xl p-6 text-center hover:scale-[1.02] transition-all duration-300 group">
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-xl bg-gradient-to-r from-accent/20 to-neon/20 group-hover:from-accent/30 group-hover:to-neon/30 transition-all duration-300">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.828 14.828a4 4 0 01-5.656 0M9 10h1m4 0h1m-6 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold mb-2">Play to Earn</h3>
              <p className="text-white/70 text-sm">Play games and get rewarded with crypto</p>
            </div>

            {/* Move to Earn */}
            <div className="glass-light rounded-2xl p-6 text-center hover:scale-[1.02] transition-all duration-300 group">
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-xl bg-gradient-to-r from-accent/20 to-neon/20 group-hover:from-accent/30 group-hover:to-neon/30 transition-all duration-300">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold mb-2">Move to Earn</h3>
              <p className="text-white/70 text-sm">Receive crypto rewards for every step you take</p>
            </div>

            {/* Gaming */}
            <div className="glass-light rounded-2xl p-6 text-center hover:scale-[1.02] transition-all duration-300 group">
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-xl bg-gradient-to-r from-accent/20 to-neon/20 group-hover:from-accent/30 group-hover:to-neon/30 transition-all duration-300">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold mb-2">Gaming</h3>
              <p className="text-white/70 text-sm">Explore hundreds of DeFi games straight from the app</p>
            </div>

            {/* dApp Store */}
            <div className="glass-light rounded-2xl p-6 text-center hover:scale-[1.02] transition-all duration-300 group">
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-xl bg-gradient-to-r from-accent/20 to-neon/20 group-hover:from-accent/30 group-hover:to-neon/30 transition-all duration-300">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold mb-2">dApp Store</h3>
              <p className="text-white/70 text-sm">Discover thousands of decentralized apps and connect directly. You can also list your own dApp</p>
            </div>

            {/* Custom Collections */}
            <div className="glass-light rounded-2xl p-6 text-center hover:scale-[1.02] transition-all duration-300 group">
              <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center rounded-xl bg-gradient-to-r from-accent/20 to-neon/20 group-hover:from-accent/30 group-hover:to-neon/30 transition-all duration-300">
                <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold mb-2">Custom Collections</h3>
              <p className="text-white/70 text-sm">Save important information and access them instantly</p>
            </div>
          </div>
        </div>
      </section>

      {/* TOKEN FACTS / UTILITIES */}
      <section id="token" className="py-16 lg:py-24 bg-black/20">
        <div className="max-w-7xl mx-auto px-2 sm:px-4 lg:px-8">
          <div className="grid lg:grid-cols-2 gap-10 items-start">
            <div>
              <h2 className="text-3xl sm:text-4xl font-bold">Token facts</h2>
              <p className="mt-3 text-white/70 max-w-xl">Launched and 100% circulating. Real utility inside the Dopamine app.</p>
              <div className="mt-6 grid grid-cols-2 sm:grid-cols-3 gap-4 text-sm">
                <div className="glass rounded-2xl p-4"><div className="text-white text-lg font-bold">$DOPE</div><div className="text-white/60">Ticker</div></div>
                <div className="glass rounded-2xl p-4"><div className="text-white text-lg font-bold">Solana</div><div className="text-white/60">Network</div></div>
                <div className="glass rounded-2xl p-4"><div className="text-white text-lg font-bold">125,000,000</div><div className="text-white/60">Total / Max Supply</div></div>
                <div className="glass rounded-2xl p-4"><div className="text-white text-lg font-bold">100%</div><div className="text-white/60">Circulating</div></div>
                <div className="glass rounded-2xl p-4 overflow-hidden"><div className="text-white text-lg font-bold">MINT</div><a href="https://solscan.io/token/8Kqmghm1mkXbKYqt2wGnHxwnRdEjD9nayNKD3EanWkcD" target="_blank" rel="noopener noreferrer" className="text-white/60 truncate block cursor-pointer hover:text-white transition-colors underline" title="Click to view on Solscan" onClick={() => trackClick({ event_name: 'click_mint_address', href: 'https://solscan.io/token/8Kqmghm1mkXbKYqt2wGnHxwnRdEjD9nayNKD3EanWkcD' })}>8Kqmghm1mkXbKYqt2wGnHxwnRdEjD9nayNKD3EanWkcD</a></div>
                <div className="glass rounded-2xl p-4"><div className="text-white text-lg font-bold">CMC</div><div className="text-white/60"><a className="underline" href="https://coinmarketcap.com/currencies/dopamine-app/" target="_blank" rel="noopener noreferrer" onClick={() => trackClick({ event_name: 'click_cmc_listing', href: 'https://coinmarketcap.com/currencies/dopamine-app/' })}>Listing</a></div></div>
                <div className="glass rounded-2xl p-4"><div className="text-white text-lg font-bold">X</div><div className="text-white/60"><a className="underline" href="https://x.com/myDopamineApp" target="_blank" rel="noopener noreferrer" onClick={() => trackClick({ event_name: 'click_x', href: 'https://x.com/myDopamineApp' })}>Follow</a></div></div>
                <div className="glass rounded-2xl p-4"><div className="text-white text-lg font-bold">Telegram</div><div className="text-white/60"><a className="underline" href="https://t.me/myDopamineApp" target="_blank" rel="noopener noreferrer" onClick={() => trackClick({ event_name: 'click_telegram', href: 'https://t.me/myDopamineApp' })}>Join</a></div></div>
              </div>
            </div>
            <div className="w-full">
              <h3 className="text-lg font-semibold mb-6">Service Tiers</h3>
              
              {/* Responsive Grid - Same as More Features */}
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
                {/* Shrimps - Free */}
                <div className="relative overflow-hidden rounded-2xl bg-gradient-to-b from-purple-500 to-purple-700 p-4 sm:p-6 text-white text-center hover:scale-[1.02] transition-all duration-300 group">
                  <div className="relative z-10">
                    <div className="text-xs uppercase tracking-wider opacity-80 mb-2">FREE SERVICES</div>
                    <h4 className="text-lg sm:text-2xl font-bold mb-3 sm:mb-4">Shrimps</h4>
                    <ul className="space-y-2 text-sm text-left">
                      <li className="flex items-center">
                        <div className="w-1.5 h-1.5 bg-white rounded-full mr-3 flex-shrink-0"></div>
                        <span>Market datas</span>
                      </li>
                      <li className="flex items-center">
                        <div className="w-1.5 h-1.5 bg-white rounded-full mr-3 flex-shrink-0"></div>
                        <span>Full Wallet</span>
                      </li>
                      <li className="flex items-center">
                        <div className="w-1.5 h-1.5 bg-white rounded-full mr-3 flex-shrink-0"></div>
                        <span>24/7 Media</span>
                      </li>
                      <li className="flex items-center">
                        <div className="w-1.5 h-1.5 bg-white rounded-full mr-3 flex-shrink-0"></div>
                        <span>Play to earn</span>
                      </li>
                      <li className="flex items-center">
                        <div className="w-1.5 h-1.5 bg-white rounded-full mr-3 flex-shrink-0"></div>
                        <span>AML Scoring</span>
                      </li>
                    </ul>
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-br from-white/10 to-transparent"></div>
                </div>

                {/* Shark - Premium */}
                <div className="relative overflow-hidden rounded-2xl bg-gradient-to-b from-blue-500 to-blue-700 p-4 sm:p-6 text-white text-center hover:scale-[1.02] transition-all duration-300 group">
                  <div className="relative z-10">
                    <div className="text-xs uppercase tracking-wider opacity-80 mb-2">PREMIUM</div>
                    <h4 className="text-lg sm:text-2xl font-bold mb-3 sm:mb-4">Shark</h4>
                    <ul className="space-y-2 text-sm text-left">
                      <li className="flex items-center">
                        <div className="w-1.5 h-1.5 bg-white rounded-full mr-3 flex-shrink-0"></div>
                        <span>All the Shrimps</span>
                      </li>
                      <li className="flex items-center">
                        <div className="w-1.5 h-1.5 bg-white rounded-full mr-3 flex-shrink-0"></div>
                        <span>AI Trading</span>
                      </li>
                      <li className="flex items-center">
                        <div className="w-1.5 h-1.5 bg-white rounded-full mr-3 flex-shrink-0"></div>
                        <span>Bots</span>
                      </li>
                      <li className="flex items-center">
                        <div className="w-1.5 h-1.5 bg-white rounded-full mr-3 flex-shrink-0"></div>
                        <span>NFT Studio</span>
                      </li>
                      <li className="flex items-center">
                        <div className="w-1.5 h-1.5 bg-white rounded-full mr-3 flex-shrink-0"></div>
                        <span>NFT WARS</span>
                      </li>
                      <li className="flex items-center">
                        <div className="w-1.5 h-1.5 bg-white rounded-full mr-3 flex-shrink-0"></div>
                        <span>Marketplace</span>
                      </li>
                    </ul>
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-br from-white/10 to-transparent"></div>
                </div>

                {/* Killer Whale - Pro */}
                <div className="relative overflow-hidden rounded-2xl bg-gradient-to-b from-pink-500 to-pink-700 p-4 sm:p-6 text-white text-center hover:scale-[1.02] transition-all duration-300 group">
                  <div className="relative z-10">
                    <div className="text-xs uppercase tracking-wider opacity-80 mb-2">PRO</div>
                    <h4 className="text-lg sm:text-2xl font-bold mb-3 sm:mb-4">Killer Whale</h4>
                    <ul className="space-y-2 text-sm text-left">
                      <li className="flex items-center">
                        <div className="w-1.5 h-1.5 bg-white rounded-full mr-3 flex-shrink-0"></div>
                        <span>Financial pass</span>
                      </li>
                      <li className="flex items-center">
                        <div className="w-1.5 h-1.5 bg-white rounded-full mr-3 flex-shrink-0"></div>
                        <span>All features packages</span>
                      </li>
                      <li className="flex items-center">
                        <div className="w-1.5 h-1.5 bg-white rounded-full mr-3 flex-shrink-0"></div>
                        <span>Investors network</span>
                      </li>
                      <li className="flex items-center">
                        <div className="w-1.5 h-1.5 bg-white rounded-full mr-3 flex-shrink-0"></div>
                        <span>VC DEAL FLOW</span>
                      </li>
                      <li className="flex items-center">
                        <div className="w-1.5 h-1.5 bg-white rounded-full mr-3 flex-shrink-0"></div>
                        <span>Monthly NFT Drop</span>
                      </li>
                      <li className="flex items-center">
                        <div className="w-1.5 h-1.5 bg-white rounded-full mr-3 flex-shrink-0"></div>
                        <span>24/7 Concierge</span>
                      </li>
                    </ul>
                  </div>
                  <div className="absolute inset-0 bg-gradient-to-br from-white/10 to-transparent"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* APP (SECOND PRIORITY) */}
      <section id="app" className="py-16 lg:py-24">
        <div className="max-w-7xl mx-auto px-2 sm:px-4 lg:px-8">
          <div className="grid lg:grid-cols-[1.1fr_.9fr] gap-8 lg:gap-10 items-center">
            <div className="text-center lg:text-left">
              <h2 className="text-3xl sm:text-4xl font-bold">Get the app</h2>
              <p className="mt-3 text-white/70 max-w-xl mx-auto lg:mx-0 text-sm sm:text-base">Dopamine is your web3 super app with rewards, swaps, bridges, and launchpad access. Holding $DOPE unlocks more.</p>
              <div className="mt-6 flex flex-col sm:flex-row gap-3">
                <a href="https://apps.apple.com/us/app/dopamine-bitcoin-crypto/id1350234503" className="w-full sm:w-auto px-5 py-3 rounded-xl bg-white text-black font-semibold text-center" onClick={() => trackClick({ event_name: 'click_app_store', href: 'https://apps.apple.com/us/app/dopamine-bitcoin-crypto/id1350234503' })}>App Store</a>
                <a href="https://play.google.com/store/apps/details?id=com.kyriakosalexandrou.coinmarketcap" className="w-full sm:w-auto px-5 py-3 rounded-xl bg-white text-black font-semibold text-center" onClick={() => trackClick({ event_name: 'click_google_play', href: 'https://play.google.com/store/apps/details?id=com.kyriakosalexandrou.coinmarketcap' })}>Google Play</a>
              </div>
              <div className="text-xs text-white/60 mt-3">Scan QR or send the link to your phone.</div>
            </div>
            <div className="glass-light rounded-3xl p-4 sm:p-6 lg:p-8 mt-8 lg:mt-0">
              <div className="flex flex-col sm:grid sm:grid-cols-2 gap-4 sm:gap-6 items-center">
                <div className="relative group w-full max-w-sm sm:max-w-none">
                  <img
                    src={image1}
                    alt="Dopamine App Screenshot 1"
                    className="w-full h-auto rounded-2xl shadow-deep hover:scale-105 transition-transform duration-300 mx-auto"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </div>
                <div className="relative group w-full max-w-sm sm:max-w-none">
                  <img
                    src={image2}
                    alt="Dopamine App Screenshot 2"
                    className="w-full h-auto rounded-2xl shadow-deep hover:scale-105 transition-transform duration-300 mx-auto"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent rounded-2xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* BACKERS / PARTNERS */}
      <section id="partners" className="py-16 bg-black/20">
        <div className="max-w-7xl mx-auto px-2 sm:px-4 lg:px-8">
          <div className="text-center mb-8 sm:mb-12">
            <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white">Our Backers</h2>
          </div>

          {/* Carousel Container */}
          <div className="relative">
            <div className="overflow-hidden">
              <div
                className="flex transition-transform duration-500 ease-in-out"
                style={{ transform: `translateX(-${currentSlide * 100}%)` }}
              >
                {/* Slide 1 */}
                <div className="w-full flex-shrink-0">
                  <div className="flex items-center justify-center">
                    <img
                      src="https://cdn.prod.website-files.com/63617268aa224e6842eae726/646920e17a64f3728eb67a95_Group%201171276294.png"
                      alt="Backers Group 1"
                      className="w-full max-w-4xl h-auto opacity-80 hover:opacity-100 transition-opacity duration-300"
                      loading="lazy"
                    />
                  </div>
                </div>

                {/* Slide 2 */}
                <div className="w-full flex-shrink-0">
                  <div className="flex items-center justify-center">
                    <img
                      src="https://cdn.prod.website-files.com/63617268aa224e6842eae726/646920e17a64f3728eb67a9a_Group%201171276355.png"
                      alt="Backers Group 2"
                      className="w-full max-w-4xl h-auto opacity-80 hover:opacity-100 transition-opacity duration-300"
                      loading="lazy"
                    />
                  </div>
                </div>

                {/* Slide 3 */}
                <div className="w-full flex-shrink-0">
                  <div className="flex items-center justify-center">
                    <img
                      src="https://cdn.prod.website-files.com/63617268aa224e6842eae726/646920e17a64f3728eb67a90_Group%201171276354.png"
                      alt="Backers Group 3"
                      className="w-full max-w-4xl h-auto opacity-80 hover:opacity-100 transition-opacity duration-300"
                      loading="lazy"
                    />
                  </div>
                </div>
              </div>
            </div>

            {/* Navigation Dots */}
            <div className="flex justify-center mt-8 space-x-2">
              {[0, 1, 2].map((index) => (
                <button
                  key={index}
                  onClick={() => {
                    setCurrentSlide(index);
                    trackClick({ event_name: `click_backers_slide_${index + 1}` });
                  }}
                  className={`w-2 h-2 rounded-full transition-all duration-300 ${
                    currentSlide === index 
                      ? 'bg-white/80 scale-125' 
                      : 'bg-white/30 hover:bg-white/50'
                  }`}
                  aria-label={`Go to slide ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* FAQ */}
      <section id="faq" className="py-16 lg:py-24">
        <div className="max-w-4xl mx-auto px-2 sm:px-4 lg:px-8">
          <h2 className="text-3xl sm:text-4xl font-bold text-center">FAQ</h2>
          <div className="mt-6 sm:mt-8 divide-y divide-white/10">
            <details className="group py-4">
              <summary
                className="cursor-pointer list-none flex items-center justify-between gap-4 text-base sm:text-lg font-semibold text-white"
                style={{color: 'white'}}
                onClick={() => trackClick({ event_name: 'click_faq_what_is_dopamine' })}
              >
                What is Dopamine?<span className="text-white/40 group-open:rotate-45 transition">＋</span>
              </summary>
              <p className="mt-2 text-white text-sm sm:text-base" style={{color: 'white'}}>Dopamine is a non-custodial, secure, and anonymous cryptocurrency mobile app wallet. Furthermore it offers a variety of features that help any type of user navigate the cryptocurrency market.</p>
            </details>

            <details className="group py-4">
              <summary
                className="cursor-pointer list-none flex items-center justify-between gap-4 text-base sm:text-lg font-semibold text-white"
                style={{color: 'white'}}
                onClick={() => trackClick({ event_name: 'click_faq_what_is_dope' })}
              >
                What is $DOPE?<span className="text-white/40 group-open:rotate-45 transition">＋</span>
              </summary>
              <p className="mt-2 text-white text-sm sm:text-base" style={{color: 'white'}}>DOPE token is the native token of Dopamine App. Holding this utility token, enables users to access premium features within the app. For businesses the Dopamine token serves as a license to power innovation.</p>
            </details>


          </div>
        </div>
      </section>

      {/* FOOTER */}
      <footer className="border-t border-white/10 py-10">
        <div className="max-w-7xl mx-auto px-2 sm:px-4 lg:px-8">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
            <div className="text-white/70 text-sm">© {new Date().getFullYear()} Dopamine. All rights reserved.</div>
            {/*<div className="flex items-center gap-4 text-sm">*/}
            {/*  <a href="#" className="hover:text-white">Docs</a>*/}
            {/*  <a href="#" className="hover:text-white">Terms</a>*/}
            {/*  <a href="" className="hover:text-white">Privacy</a>*/}
            {/*  <a href="#" className="hover:text-white">X</a>*/}
            {/*  <a href="#" className="hover:text-white">Discord</a>*/}
            {/*</div>*/}
          </div>
        </div>
      </footer>
      </div>
  );
};

export default App;
